<template>
  <tfoot v-if="filteredResults !== undefined && filteredResults.length > 0">
    <tr class="search__result__footer">
      <td colspan="3" class="search__result__footer--count-of-result">
        Zeige
        <select name="_perPage" v-model="$parent.search._perPage">
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
        </select>
        Einträge pro Seite.
      </td>
      <td colspan="3" class="search__result__footer--paginator">
        <!-- - - >
        page: '{{ $parent.search._page }}', totalPages: '{{ totalPages }}', totalResults: '{{ totalResults }}'
        < ! - - -->
        <button
          type="button"
          :disabled="$parent.isPreviousButtonDisabled"
          @click="$parent.previousPage"
          >«</button>
        <button
          type="button"
          v-for="pageNumber in getPaginationButtonList"
          v-bind:key="pageNumber"
          :disabled="pageNumber == $parent.search._page || typeof pageNumber === 'string'"
          :class="{ active: (pageNumber == $parent.search._page) }"
          @click="$parent.goToPage"
          :data-page="pageNumber"
          >{{ pageNumber }}</button>
        <button
          type="button"
          :disabled="$parent.isNextButtonDisabled"
          @click="$parent.nextPage"
          >»</button>
      </td>
    </tr>
  </tfoot>
</template>

<script>
export default {
  name: 'SearchResultFooter',
  components: {
  },
  props: {
    filteredResults: Array,
    totalPages: Number,
    totalResults: Number,
    getPaginationButtonList: Array
  }
}
</script>

<style lang="scss">
  .search__result__footer {
    td {
      padding: 0.5em 0;
    }
    .search__result__footer--paginator {
      text-align: right;

      button {
        min-width: 41px;
        text-align: center;
        border: 1px solid #ccc;
        margin: 0 0 0 0.2em;
        color: #000;
        &[disabled] {
          color: #999;
        }
        &[disabled].active {
          color: red;
          font-weight: bold;
        }
      }
    }
  }
</style>
